import React from "react";

import {
  Card,
  CardBody,
  Skeleton,
  Flex,
  FlexItem
} from "@patternfly/react-core";

const ResourcePanelSkeleton = ({ name = "zasobów" }) => (
  <Card isCompact>
    <CardBody>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          minHeight: "180px"
        }}
      >
        <Skeleton
          width="100%"
          height="24px"
          screenreaderText={`Ładowanie panelu ${name}`}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%"
          }}
        >
          <Skeleton width="50%" />
          <Skeleton width="10%" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%"
          }}
        >
          <Skeleton width="30%" />
          <Skeleton width="20%" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%"
          }}
        >
          <Skeleton width="100%" height="250px"/>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%"
          }}
        >
          <Skeleton width="100%" height="200px"/>
        </div>
      </div>
    </CardBody>
  </Card>
);

export default ResourcePanelSkeleton;